import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import "core-js/modules/es6.array.find";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getContractFiltered } from '../helpers';
import { getDisplayNameV2 } from '../cms/divisionCodeDisplayNameMap';

// Note: comparisons between newState and oldState are shallow.
// differences in array order and structure of objects
// will be returned as a change
var findChangedState = function findChangedState(currentState, newState) {
  return _Object$keys(newState).filter(function (key) {
    return _JSON$stringify(currentState[key]) !== _JSON$stringify(newState[key]);
  }).reduce(function (state, key) {
    state[key] = newState[key];
    return state;
  }, {});
};

var updateState = function updateState(currentState, changedState) {
  var state = _objectSpread({}, currentState, {}, changedState);

  var derivedState;

  if (!state.addresses || !_Array$isArray(state.addresses) || state.addresses.length === 0) {
    /**  The below alert causes an error notification to be sent but with our current v1 / v2 model,
     * it won't work. Will need to re-enabled once all apps move to v2
     */
    // logger.warn('@od/sac, addresses are empty', state.addresses);
    // dispatchInvalidAccountErrorEvent();
    return state;
  }

  if (changedState.contractAccountId) {
    derivedState = derivedStateByContractAccountId(state.addresses, state.properties, changedState.contractAccountId);
  } else if (changedState.premiseId) {
    derivedState = derivedStateByPremiseId(state.addresses, state.properties, changedState.premiseId);
  } else if (changedState.selectedServiceId) {
    derivedState = derivedStateByServiceId(state.addresses, state.properties, changedState.selectedServiceId);
  } else if (changedState.selectedAddressId) {
    derivedState = derivedStateByAddressId(state.addresses, state.properties, changedState.selectedAddressId);
  } else if (changedState.addresses) {
    derivedState = derivedStateByAddressId(state.addresses, state.properties, state.selectedAddressId);
  }

  if (derivedState) {
    state = _objectSpread({}, state, {}, derivedState);
  }

  return state;
};

var derivedStateByAddressId = function derivedStateByAddressId(addresses, properties, addressId) {
  var foundAddress = findByAddressId(addresses, addressId);
  var selectedAddress = foundAddress ? foundAddress : findPrimaryAddress(addresses);
  var selectedService = selectedAddress.services[0];
  return derivedStateByAddress(properties, selectedAddress, selectedService);
};

var derivedStateByServiceId = function derivedStateByServiceId(addresses, properties, serviceId) {
  var foundAddress = findSelectedAddressByServiceId(addresses, serviceId);
  var selectedAddress = foundAddress ? foundAddress : findPrimaryAddress(addresses);
  var foundService = selectedAddress.services.find(function (s) {
    return s.id === serviceId;
  });
  var selectedService = foundService ? foundService : selectedAddress.services[0];
  return derivedStateByAddress(properties, selectedAddress, selectedService);
};

var derivedStateByPremiseId = function derivedStateByPremiseId(addresses, properties, premiseId) {
  var foundProperty = findByPremiseId(properties, premiseId);
  var selectedProperty = foundProperty ? foundProperty : findPrimaryProperty(properties);
  return derivedStateByContractAccountId(addresses, properties, selectedProperty.contractAccounts[0].contractAccountId);
};

var derivedStateByContractAccountId = function derivedStateByContractAccountId(addresses, properties, contractAccountId) {
  var foundAddress = findSelectedAddressByBackendServiceId(addresses, contractAccountId);
  var selectedAddress = foundAddress ? foundAddress : findPrimaryAddress(addresses);
  var foundService = selectedAddress.services.find(function (s) {
    return s.backendId === contractAccountId;
  });
  var selectedService = foundService ? foundService : selectedAddress.services[0];
  return derivedStateByAddress(properties, selectedAddress, selectedService);
};

var derivedStateByAddress = function derivedStateByAddress(properties, selectedAddress, selectedService) {
  var selectedProperty = findSelectedPropertyByBackendServiceId(properties, selectedService.backendId);
  var contractsFiltered = selectedProperty ? getContractFiltered(selectedProperty) : [];
  var servicesForSelectedAddress = getServicesForCurrentProperty(selectedAddress);
  return {
    contractAccountId: selectedService.backendId,
    contractsFiltered: contractsFiltered,
    premiseId: selectedProperty ? selectedProperty.premiseId : '',
    selectedAddressId: selectedAddress.id,
    selectedServiceId: selectedService.id,
    servicesForSelectedAddress: servicesForSelectedAddress
  };
};

var getStateChangeFromQueryParams = function getStateChangeFromQueryParams(queryParams) {
  if (!queryParams) {
    return {};
  }

  if (queryParams.premiseId) {
    return {
      premiseId: queryParams.premiseId
    };
  }

  if (queryParams.contractAccountId) {
    return {
      contractAccountId: queryParams.contractAccountId
    };
  }

  if (queryParams.selectedAddressId) {
    return {
      selectedAddressId: queryParams.selectedAddressId
    };
  }

  if (queryParams.selectedServiceId) {
    return {
      selectedServiceId: queryParams.selectedServiceId
    };
  }

  return {};
};

var getServicesForCurrentProperty = function getServicesForCurrentProperty(address) {
  return address.services.map(function (service) {
    return convertServiceToFilteredService(service, address);
  });
};

var convertServiceToFilteredService = function convertServiceToFilteredService(service, address) {
  return {
    addressId: address.id,
    id: service.id,
    status: service.status,
    type: service.type,
    typeDisplayName: getDisplayNameV2(service.type)
  };
};

var findSelectedAddressByBackendServiceId = function findSelectedAddressByBackendServiceId(addresses, backendServiceId) {
  var addressFound = addresses.find(function (a) {
    return (a.services || []).find(function (service) {
      return service.backendId === backendServiceId;
    }) != null;
  });
  return addressFound ? addressFound : findPrimaryAddress(addresses);
};

var findSelectedAddressByServiceId = function findSelectedAddressByServiceId(addresses, serviceId) {
  var addressFound = addresses.find(function (a) {
    return (a.services || []).find(function (service) {
      return service.id === serviceId;
    }) != null;
  });
  return addressFound ? addressFound : findPrimaryAddress(addresses);
};

var findSelectedPropertyByBackendServiceId = function findSelectedPropertyByBackendServiceId(properties, backendServiceId) {
  var propertyFound = properties.find(function (p) {
    return (p.contractAccounts || []).find(function (contractAccounts) {
      return contractAccounts.contractAccountId === backendServiceId;
    }) != null;
  });
  return propertyFound ? propertyFound : findPrimaryProperty(properties);
};

var findPrimaryProperty = function findPrimaryProperty(properties) {
  var property = properties.find(function (p) {
    return p.premisePrimary;
  });
  return property ? property : properties[0];
};

var findPrimaryAddress = function findPrimaryAddress(addresses) {
  var address = addresses.find(function (a) {
    return a.primary;
  });
  return address ? address : addresses[0];
};

var findByPremiseId = function findByPremiseId(properties, premiseId) {
  return properties.find(function (p) {
    return p.premiseId === premiseId;
  });
};

var findByAddressId = function findByAddressId(addresses, addressId) {
  return addresses.find(function (address) {
    return address.id === addressId;
  });
};

export { findChangedState, updateState, getStateChangeFromQueryParams };